import _ from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

import { getTagSVGStyle } from '../styles/tag-SVG-styles';
import { svgConfig } from '../utils/svg-config';
import { generateTag } from '../utils/tag-generator';

const TagSVGUnstyled = (props) => {
  const {
    tag,
    renderImage,
    classes,
  } = props;
  const {
    id,
    type,
  } = tag;

  const i18n = useContext(I18nContext);
  const permissions = useContext(PermissionsContext);
  const isUetSpaTrackingEnabled = _.result(permissions.dynamic, 'UetAutoSpaTracking');

  const tagContent = useMemo(() =>
    generateTag(type, id, false, undefined, isUetSpaTrackingEnabled), [type, id, isUetSpaTrackingEnabled]);

  const onRenderText = useMemo(() => (
    <text role="region" aria-label={i18n.getString(_TL_('Tracking tag code'))}>
      {_.map(tagContent.split('\n'), (line, idx) => (
        <tspan
          x={svgConfig.text.xOffset}
          y={svgConfig.text.yOffset + (idx * svgConfig.text.lineHeight)}
          key={idx}
          className={svgConfig.text.classname}
        >
          {line}
        </tspan>
      ))}
    </text>
  ), [i18n, tagContent]);

  const onRenderImage = useMemo(() => (
    <svg
      x={svgConfig[type].rect.width}
      width={svgConfig[type].image.width}
      height={svgConfig[type].image.height}
      viewBox={svgConfig[type].image.viewBox}
      fill={svgConfig[type].image.fill}
      xmlns={svgConfig.xmlns}
    >
      {svgConfig[type].image.template}
    </svg>
  ), [type]);

  const onRenderSVG = useMemo(() => (
    <svg
      width={renderImage ? svgConfig[type].svg.withImage.width : svgConfig[type].svg.noImage.width}
      height={renderImage ? svgConfig[type].svg.withImage.height : svgConfig[type].svg.noImage.height}
      viewBox={renderImage ? svgConfig[type].svg.withImage.viewBox : svgConfig[type].svg.noImage.viewBox}
      xmlns={svgConfig.xmlns}
    >
      <rect
        width={svgConfig[type].rect.width}
        height={svgConfig[type].rect.height}
        x={svgConfig[type].rect.x}
        fill={svgConfig[type].rect.fill}
      />
      {onRenderText}
      {renderImage && onRenderImage}
    </svg>
  ), [type, onRenderText, renderImage, onRenderImage]);

  return (
    <div className={classNames(classes.container, 'tag-svg')}>
      {onRenderSVG}
    </div>
  );
};

TagSVGUnstyled.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.oneOf(['Container', 'UET']).isRequired,
  }).isRequired,
  renderImage: PropTypes.bool,
  classes: PropTypes.shape(_.mapObject(
    getTagSVGStyle(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
};

TagSVGUnstyled.defaultProps = {
  renderImage: true,
};

export const TagSVG = withDefaultStyles(TagSVGUnstyled, getTagSVGStyle);
